import { FormattedCurrency } from '@iwIntlProvider/FormattedCurrency';
import { TopUpStatusAlertBox } from './TopUpStatusAlertBox';
import styles from '../TopUpStatusAlertBox.module.css';

export const NotYetTopUpEligibleAlert = ({
    amountToRepayBeforeTopUp
}: {
    amountToRepayBeforeTopUp: number;
}) => {
    return (
        <TopUpStatusAlertBox
            variant="cancel"
            iconName="infoCircleOutline"
            className={styles.blueAlertBox}
            iconClassName={styles.blueAlertBoxIcon}
            description={
                <>
                    <strong>
                        You can request more funds once you've repaid{' '}
                        <FormattedCurrency value={amountToRepayBeforeTopUp} /> -
                    </strong>{' '}
                    You've passed our eligibility checks but your approval will
                    still be subject to a credit review
                </>
            }
        />
    );
};
